/**
 * @see https://fontawesome.com/how-to-use/with-the-api/setup/importing-icons
 */

import {library} from '@fortawesome/fontawesome-svg-core'
// import {} from '@fortawesome/free-solid-svg-icons'
// import {} from '@fortawesome/free-regular-svg-icons'
// import {} from '@fortawesome/free-brands-svg-icons'
// import {} from '@fortawesome/pro-solid-svg-icons'
// import {} from '@fortawesome/pro-regular-svg-icons'

import {faCalendarAlt} from '@fortawesome/pro-light-svg-icons/faCalendarAlt'
import {faCartArrowDown} from '@fortawesome/pro-regular-svg-icons/faCartArrowDown'
import {faCartPlus} from '@fortawesome/pro-regular-svg-icons/faCartPlus'
import {faCcMastercard} from '@fortawesome/free-brands-svg-icons/faCcMastercard'
import {faCcVisa} from '@fortawesome/free-brands-svg-icons/faCcVisa'
import {faCcAmex} from '@fortawesome/free-brands-svg-icons/faCcAmex'
import {faCcPaypal} from '@fortawesome/free-brands-svg-icons/faCcPaypal'
import {faChartLine} from '@fortawesome/pro-regular-svg-icons/faChartLine'
import {faCheck} from '@fortawesome/pro-regular-svg-icons/faCheck'
import {faCheckCircle} from '@fortawesome/pro-light-svg-icons/faCheckCircle'
import {faChevronDown} from '@fortawesome/pro-light-svg-icons/faChevronDown'
import {faChevronLeft} from '@fortawesome/pro-light-svg-icons/faChevronLeft'
import {faChevronUp} from '@fortawesome/pro-light-svg-icons/faChevronUp'
import {faClock as falFaClock} from '@fortawesome/pro-light-svg-icons/faClock'
import {faClone} from '@fortawesome/pro-light-svg-icons/faClone'
import {faCog} from '@fortawesome/pro-light-svg-icons/faCog'
import {faCogs} from '@fortawesome/pro-regular-svg-icons/faCogs'
import {faComments} from '@fortawesome/pro-regular-svg-icons/faComments'
import {faCreditCard as falFaCreditCard} from '@fortawesome/pro-light-svg-icons/faCreditCard'
import {faCreditCard as farFaCreditCard} from '@fortawesome/pro-regular-svg-icons/faCreditCard'
import {faCube} from '@fortawesome/pro-regular-svg-icons/faCube'
import {faCubes} from '@fortawesome/pro-regular-svg-icons/faCubes'
import {faEnvelope as falFaEnvelope} from '@fortawesome/pro-light-svg-icons/faEnvelope'
import {faEnvelope as farFaEnvelope} from '@fortawesome/pro-regular-svg-icons/faEnvelope'
import {faExclamationCircle} from '@fortawesome/pro-light-svg-icons/faExclamationCircle'
import {faFacebook} from '@fortawesome/free-brands-svg-icons/faFacebook'
import {faFighterJet} from '@fortawesome/pro-regular-svg-icons/faFighterJet'
import {faFile as falFaFile} from '@fortawesome/pro-light-svg-icons/faFile'
import {faFile as farFaFile} from '@fortawesome/pro-regular-svg-icons/faFile'
import {faFileAlt} from '@fortawesome/pro-regular-svg-icons/faFileAlt'
import {faFileArchive} from '@fortawesome/pro-light-svg-icons/faFileArchive'
import {faFileAudio} from '@fortawesome/pro-light-svg-icons/faFileAudio'
import {faFileImage} from '@fortawesome/pro-light-svg-icons/faFileImage'
import {faFilePdf} from '@fortawesome/pro-light-svg-icons/faFilePdf'
import {faFileVideo} from '@fortawesome/pro-light-svg-icons/faFileVideo'
import {faFlag} from '@fortawesome/pro-light-svg-icons/faFlag'
import {faGift} from '@fortawesome/pro-light-svg-icons/faGift'
import {faGlobe} from '@fortawesome/pro-regular-svg-icons/faGlobe'
import {faGooglePlus} from '@fortawesome/free-brands-svg-icons/faGooglePlus'
import {faHeart as falFaHeart} from '@fortawesome/pro-light-svg-icons/faHeart'
import {faHeart as farFaHeart} from '@fortawesome/pro-regular-svg-icons/faHeart'
import {faHeart as fasFaHeart} from '@fortawesome/pro-solid-svg-icons/faHeart'
import {faStar as falFaStar} from '@fortawesome/pro-light-svg-icons/faStar'
import {faStar as fasFaStar} from '@fortawesome/pro-solid-svg-icons/faStar'
import {faStarHalf as falFaStarHalf} from '@fortawesome/pro-light-svg-icons/faStarHalf'
import {faStarHalf as fasFaStarHalf} from '@fortawesome/pro-solid-svg-icons/faStarHalf'
import {faHome} from '@fortawesome/pro-light-svg-icons/faHome'
import {faList as falFaList} from '@fortawesome/pro-light-svg-icons/faList'
import {faLocation} from '@fortawesome/pro-light-svg-icons/faLocation'
import {faLocationArrow} from '@fortawesome/pro-regular-svg-icons/faLocationArrow'
import {faMapMarkerAlt} from '@fortawesome/pro-light-svg-icons/faMapMarkerAlt'
import {faMobile} from '@fortawesome/pro-light-svg-icons/faMobile'
import {faMinus} from '@fortawesome/pro-light-svg-icons/faMinus'
import {faPencil} from '@fortawesome/pro-light-svg-icons/faPencil'
import {faPhone} from '@fortawesome/pro-light-svg-icons/faPhone'
import {faPlus} from '@fortawesome/pro-light-svg-icons/faPlus'
import {faQuestionCircle} from '@fortawesome/pro-light-svg-icons/faQuestionCircle'
import {faRocket} from '@fortawesome/pro-regular-svg-icons/faRocket'
import {faSave} from '@fortawesome/pro-light-svg-icons/faSave'
import {faSearch as falFaSearch} from '@fortawesome/pro-light-svg-icons/faSearch'
import {faShareAlt} from '@fortawesome/pro-solid-svg-icons/faShareAlt'
import {faShoppingCart as falFaShoppingCart} from '@fortawesome/pro-light-svg-icons/faShoppingCart'
import {faShoppingCart as farFaShoppingCart} from '@fortawesome/pro-regular-svg-icons/faShoppingCart'
import {faSitemap} from '@fortawesome/pro-light-svg-icons/faSitemap'
import {faSpinner} from '@fortawesome/pro-regular-svg-icons/faSpinner'
import {faSlidersH} from '@fortawesome/pro-regular-svg-icons/faSlidersH'
import {faTag} from '@fortawesome/pro-light-svg-icons/faTag'
import {faTags} from '@fortawesome/pro-regular-svg-icons/faTags'
import {faTasks} from '@fortawesome/pro-regular-svg-icons/faTasks'
import {faThLarge} from '@fortawesome/pro-regular-svg-icons/faThLarge'
import {faTimes} from '@fortawesome/pro-light-svg-icons/faTimes'
import {faTimesCircle} from '@fortawesome/pro-light-svg-icons/faTimesCircle'
import {faTrash} from '@fortawesome/pro-light-svg-icons/faTrash'
import {faTrashAlt} from '@fortawesome/pro-light-svg-icons/faTrashAlt'
import {faTruck as falFaTruck} from '@fortawesome/pro-light-svg-icons/faTruck'
import {faTruck as farFaTruck} from '@fortawesome/pro-regular-svg-icons/faTruck'
import {faUser as falFaUser} from '@fortawesome/pro-light-svg-icons/faUser'
import {faUser as farFaUser} from '@fortawesome/pro-regular-svg-icons/faUser'
import {faUsers} from '@fortawesome/pro-regular-svg-icons/faUsers'
import {faTachometerAlt} from '@fortawesome/pro-light-svg-icons/faTachometerAlt'
import {faTwitter} from '@fortawesome/free-brands-svg-icons/faTwitter'
import {faWhatsapp} from '@fortawesome/free-brands-svg-icons/faWhatsapp'
import {faInfoCircle} from '@fortawesome/pro-light-svg-icons/faInfoCircle'

// B2B
import {faSignOut} from '@fortawesome/pro-light-svg-icons/faSignOut'
import {faSearch as farFaSearch} from '@fortawesome/pro-regular-svg-icons/faSearch'
import {faAngleRight} from '@fortawesome/pro-regular-svg-icons/faAngleRight'
import {faArrowRight} from '@fortawesome/pro-light-svg-icons/faArrowRight'
import {faTh} from '@fortawesome/pro-solid-svg-icons/faTh'
import {faList as farFaList} from '@fortawesome/pro-regular-svg-icons/faList'
import {faPrint} from '@fortawesome/pro-light-svg-icons/faPrint'
import {faSync} from '@fortawesome/pro-light-svg-icons/faSync'
import {faAngleDown} from '@fortawesome/pro-light-svg-icons/faAngleDown'
import {faExternalLink} from '@fortawesome/pro-light-svg-icons/faExternalLink'
import {faClock as farFaClock} from '@fortawesome/pro-regular-svg-icons/faClock'


// Add all icons to the library so you can use it in your page
library.add(
  faCalendarAlt,
  faCartArrowDown,
  faCartPlus,
  faCcMastercard,
  faCcVisa,
  faCcAmex,
  faCcPaypal,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronUp,
  falFaClock,
  faClone,
  faCog,
  faCogs,
  faComments,
  falFaCreditCard,
  farFaCreditCard,
  faCube,
  faCubes,
  falFaEnvelope,
  farFaEnvelope,
  faExclamationCircle,
  faFacebook,
  falFaFile,
  farFaFile,
  faFileAlt,
  faFileArchive,
  faFileAudio,
  faFileImage,
  faFilePdf,
  faFileVideo,
  faFighterJet,
  faFlag,
  faGift,
  faGlobe,
  faGooglePlus,
  falFaHeart,
  farFaHeart,
  fasFaHeart,
  faHome,
  falFaList,
  faLocation,
  faLocationArrow,
  faMapMarkerAlt,
  faMobile,
  faMinus,
  faPencil,
  faPhone,
  faPlus,
  faQuestionCircle,
  faRocket,
  faSave,
  falFaSearch,
  faShareAlt,
  falFaShoppingCart,
  farFaShoppingCart,
  faSitemap,
  faSlidersH,
  faSpinner,
  faTag,
  faTags,
  faTasks,
  faThLarge,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  falFaTruck,
  farFaTruck,
  falFaUser,
  farFaUser,
  faUsers,
  faTachometerAlt,
  faTwitter,
  faWhatsapp,
  falFaStar,
  fasFaStar,
  falFaStarHalf,
  fasFaStarHalf,
  faInfoCircle,

  faSignOut,
  farFaSearch,
  faAngleRight,
  faArrowRight,
  faTh,
  farFaList,
  faPrint,
  faSync,
  faAngleDown,
  faExternalLink,
  farFaClock
);

export default library;



// WEBPACK FOOTER //
// ./public/themes/frontend/museo/assets/js/icons.js